module.exports = __webpack_public_path__ + "img/home-icon-2.14f8dcf8.svg";